export type Theme = 'dark' | 'light'

export const themeLocalStorageKey = 'payload-theme'

export const defaultTheme = 'light'
